export const convertFullAddress = (data?: {
  address?: string;
  wardName?: string;
  provinceName?: string;
}) => {
  if (!data) {
    return '';
  }

  return [data.address || '', data.wardName || '', data.provinceName || '']
    .filter(Boolean)
    .join(',');
};

export const MAX_LENGTH_NOTE = 250;
